import React, { useMemo } from "react";

import { Table } from "antd";

import { LdasCategoryBadge, LdasCountBadge } from "../LdasUtils";

const getLdasProductTableColumns = ({ onEdit, onDetail, onDelete } = {}) => [
  {
    title: "제품명",
    dataIndex: "productName",
    key: "productName",
    render: (value, record) => {
      const name = value ?? record.productName ?? "";
      const host = (process.env.REACT_APP_S3_HOST || "").replace(/\/$/, "");
      const src = record.imageUrl ? `${host}/${record.imageUrl}` : null;
      return (
        <div className="ldas-product-name-cell">
          {src ? (
            <img src={src} alt="" className="ldas-product-name-cell__image" />
          ) : (
            <span className="ldas-product-name-cell__icon" aria-hidden>
              📦
            </span>
          )}
          <span className="ldas-product-name-cell__text">{name}</span>
        </div>
      );
    },
  },
  {
    title: "브랜드",
    dataIndex: "brandName",
    key: "brandName",
    render: (value) => <span className="ldas-cell-text">{value ?? ""}</span>,
  },
  {
    title: "카테고리",
    key: "category",
    render: (_, record) => (
      <LdasCategoryBadge
        label={
          (record.categories ?? [])
            .map((c) => (typeof c === "string" ? c : c?.name))
            .filter(Boolean)
            .join(", ") || "-"
        }
      />
    ),
  },
  {
    title: "로트 수",
    dataIndex: "lotCount",
    key: "lotCount",
    render: (value) => <LdasCountBadge count={value ?? 0} />,
  },
  {
    title: "인증 수",
    dataIndex: "certCount",
    key: "certCount",
    align: "center",
    render: (value) => <LdasCountBadge count={value ?? 0} />,
  },
  {
    title: "리포트 수",
    dataIndex: "reportCount",
    key: "reportCount",
    align: "center",
    render: (value) => <LdasCountBadge count={value ?? 0} />,
  },
  {
    title: "등록일",
    key: "registeredAt",
    render: (_, record) => (
      <span className="ldas-cell-date">
        {record.registeredAt ?? record.createdAt ?? "-"}
      </span>
    ),
  },
  {
    title: "관리",
    key: "actions",
    align: "center",
    render: (_, record) => (
      <div className="ldas-actions-cell">
        <button
          type="button"
          className="ldas-action-btn"
          // onClick={() => onEdit?.(record.id)}
          onClick={() => onDetail?.(record.id)}
        >
          상세
        </button>
        <button
          type="button"
          className="ldas-action-btn"
          onClick={() => onEdit?.(record.id)}
        >
          수정
        </button>
        <button
          type="button"
          className="ldas-action-btn ldas-action-btn--danger"
          aria-label="제품 삭제"
          onClick={() => onDelete?.(record)}
        >
          삭제
        </button>
      </div>
    ),
  },
];

const LdasProductTable = ({
  dataSource,
  onEdit,
  onDetail,
  onDelete,
  loading,
  pagination,
}) => {
  const columns = useMemo(
    () => getLdasProductTableColumns({ onEdit, onDetail, onDelete }),
    [onEdit, onDetail, onDelete],
  );

  return (
    <div className="ldas-table-card">
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey="id"
        pagination={pagination}
        size="middle"
        components={{
          header: {
            cell: ({ children, className, style, ...rest }) => (
              <th
                {...rest}
                className={["ldas-table-header-cell", className]
                  .filter(Boolean)
                  .join(" ")}
                style={style}
              >
                {children}
              </th>
            ),
          },
        }}
        hideOnSinglePage={false}
      />
    </div>
  );
};

export default LdasProductTable;
